import Title from "../shared/Title";
function Presentation() {
  return (
    <>
      <Title title="Présentation" />
      <div className="animate__animated animate__backInLeft">
        <p>Nom: ANDRIANOMENTSOA</p>
        <p>Prénom: Aimé Joseph</p>
        <p>Ne le: 09 Avril 1994 à Miandrarivo</p>
        <p>Situation familiale: Marié</p>
        <p>Nationalité : Malagasy</p>
        <p>Tel: 034 01 657 88</p>
        <p>Email: aaimjoseph@gmail.com</p>
      </div>
    </>
  );
}
export default Presentation;
